import * as React from "react";
import { Redirect as _Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { RedirectContext } from "../contexts";
import { withContext } from "../contexts/withContext";
export class Redirector extends React.PureComponent {
    componentDidMount() {
        if (this.props.needsToRedirect) {
            this.props.stopRedirection();
        }
    }
    componentDidUpdate() {
        if (this.props.needsToRedirect) {
            this.props.stopRedirection();
        }
    }
    render() {
        const { toPath, needsToRedirect } = this.props;
        let push = true;
        if (typeof toPath === "object" && toPath.search.includes("mode")) {
            push = false;
        }
        if (needsToRedirect) {
            return React.createElement(_Redirect, { push: push, to: toPath });
        }
        return null;
    }
}
const mapStateToProps = (state, { redirect }) => {
    return {
        toPath: redirect.selectors.getPath(state.redirect),
        needsToRedirect: redirect.selectors.hasToRedirect(state.redirect)
    };
};
const mapDispatchToProps = (dispatch, { redirect }) => {
    return {
        stopRedirection: () => dispatch(redirect.actions.stopRedirection())
    };
};
const Connected = connect(mapStateToProps, mapDispatchToProps)(Redirector);
const contextConfig = {
    redirect: RedirectContext
};
export const Redirect = withContext(contextConfig)(Connected);
//# sourceMappingURL=Redirect.js.map